/* tslint:disable */

/**
 * This file was automatically generated by "Swaxios".
 * It should not be modified by hand.
 */

import axios, { AxiosInstance, AxiosRequestConfig } from 'axios'
import { ClasificacionService, UnidadDocumentalService } from './rest/api/'

export class APIClient {
  private readonly httpClient: AxiosInstance

  constructor (baseURL: string)
  constructor (config: AxiosRequestConfig)
  constructor (configOrBaseURL: AxiosRequestConfig | string) {
    if (typeof configOrBaseURL === 'string') {
      configOrBaseURL = { baseURL: configOrBaseURL, }
    }

    this.httpClient = axios.create(configOrBaseURL)
  }

  get rest () {
    return {
      api: {
        clasificacionService: new ClasificacionService(this.httpClient),
        unidadDocumentalService: new UnidadDocumentalService(this.httpClient),
      },
    }
  }

  get defaults () {
    return this.httpClient.defaults
  }

  get interceptors () {
    return this.httpClient.interceptors
  }
}
